import {Component, OnInit, signal} from '@angular/core';
import {PrimeTemplate} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';
import {MatIcon} from '@angular/material/icon';
import {TooltipModule} from 'primeng/tooltip';
import {MatButton, MatIconButton, MatMiniFabButton} from '@angular/material/button';
import {ActivatedRoute, Router} from '@angular/router';
import {KeycloakUserService} from '../../../service/keycloak/keycloak-user.service';
import {KeycloakUser} from '../../../model/keycloak/keycloak-user.model';
import {CantaaMessageService} from '../../../service/cantaa-message.service';
import {CantaaErrorHandlerService} from '../../../service/cantaa-error-handler.service';
import {CantaaLocalizationService} from '../../../service/cantaa-localization.service';
import {HasPermissionDirective} from '../../../directive/has-permission.directive';
import {Permission} from '../../../constants/Permission';

@Component({
  selector: 'wim-system-job',
  standalone: true,
  imports: [
    PrimeTemplate,
    TableModule,
    TranslateModule,
    MatIcon,
    TooltipModule,
    MatIconButton,
    MatMiniFabButton,
    HasPermissionDirective,
    MatButton
  ],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent implements OnInit {
  keycloakUsers = signal<KeycloakUser[]>([]);

  constructor(private keycloakUserService: KeycloakUserService,
              private messageService: CantaaMessageService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private errorHandler: CantaaErrorHandlerService,
              private localization: CantaaLocalizationService) {
  }

  async ngOnInit() {
    await this.fetchKeycloakUsers();
  }

  async fetchKeycloakUsers() {
    try {
      const organizationId = null;  // FIXME user organizationId of currently logged in user
      const users = await this.keycloakUserService.getKeycloakUsers(organizationId);
      this.keycloakUsers.set(users);
    } catch (e) {
      this.errorHandler.handleError(e, 'FAILED_TO_FETCH');
      throw e;
    }
  }

  public async toEditPage(keycloakId: string) {
    await this.router.navigate([keycloakId], { relativeTo: this.activatedRoute });
  }

  async createNew() {
    await this.router.navigate(['new'], { relativeTo: this.activatedRoute });
  }

  async delete(keycloakId: string, username: string) {
    if (confirm(username + ' ' + this.localization.instant('DELETE.DELETE') + '?')) {
      try {
        await this.keycloakUserService.deleteKeycloakUser(keycloakId);
        this.messageService.success('DELETE.SUCCESS');
        await this.fetchKeycloakUsers();
      } catch (e) {
        throw this.errorHandler.handleError(e, 'DELETE.FAILED');
      }
    }
  }

  protected readonly Permission = Permission;
}
